import React from 'react';
import ContactForm from '../../components/ContactForm/ContactForm';
import styles from './Contact.module.css';

const Contact = () => {
  return (
    <div className={styles.contact}>
      <ContactForm />
    </div>
  );
};

export default Contact;
